<button type="button" class="lf-menu-row" [attr.id]="triggerId || null" (click)="rowClick.emit()">
  <ion-icon class="lf-menu-row__icon" [name]="icon"></ion-icon>
  <span class="lf-menu-row__label">{{ label }}</span>
  <ion-icon class="lf-menu-row__chevron" name="chevron-forward-outline"></ion-icon>
</button>
